import { render, staticRenderFns } from "./layout-body.vue?vue&type=template&id=cc3a5df6&scoped=true&"
import script from "./layout-body.vue?vue&type=script&lang=js&"
export * from "./layout-body.vue?vue&type=script&lang=js&"
import style0 from "./layout-body.vue?vue&type=style&index=0&id=cc3a5df6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc3a5df6",
  null
  
)

export default component.exports